import { StyleSheet } from 'react-native';
import { PALETTE, SIZES, MQ_TABLET } from '../../../../../../../src/constants';
import { MediaQueryStyleSheet } from "react-native-responsive";

export default MediaQueryStyleSheet.create({
  textSize: {
    fontSize: 10
  },
  root: {
    flex: .1,
    paddingHorizontal: 10,
    paddingTop: 20,
  }
},
{ 
  [MQ_TABLET]: {
    textSize: {
      fontSize: 12
    }
  },
});
